import PersonGroupPersonsContainer from './PersonGroupPersons.container';

export default PersonGroupPersonsContainer;
